<template>
  <div>
    <div id="headerReg">
      <div class="header990">
        <div id="aliLogo" class="util-left">
          {{ $t('beseller.title') }}
        </div>
      </div>
      <!-- header990 -->
      <div style="clear: both"></div>
    </div>
    <div id="root" data-spm-anchor-id="a2g0s.buyerloginandregister.0.i2.f04955a3xp6XrO">
      <!-- 第一步填写基本信息 -->
      <div class="login-container" v-if="step == 1">
        <!-- 个人信息 -->
        <div class="batman-pc">
          <div class="comet-tabs">
            <div class="comet-tabs-container">
              <div class="comet-tabs-pane comet-tabs-pane-active">
                <div class="shop-title">{{ $t('beseller.account') }}</div>
                <div class="fm-login nc-outer-box">
                  <!-- 邮箱 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('signup.email') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field fm-field-phone">
                    <span class="comet-input-label-wrapper">
                      <span class="comet-input-label-content">
                        <input :placeholder="$t('signup.email')" autocapitalize="off" type="text" class="comet-input" v-model="params.email" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                  <!-- 密码 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('signup.password') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field">
                    <span class="comet-input-label-wrapper comet-input-password">
                      <span class="comet-input-label-content">
                        <input maxlength="40" type="password" :placeholder="$t('signup.password')" autocapitalize="off" class="comet-input" v-model="params.passwd" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                        <span class="comet-icon comet-icon-watchingoff comet-input-password-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path
                              d="M234.421333 189.269333l1.536 1.44 597.333334 597.333334a32 32 0 0 1-43.712 46.688l-1.536-1.44-39.722667-39.712C679.498667 845.184 600.170667 874.666667 512 874.666667c-127.029333 0-234.773333-61.088-319.68-161.738667a600.352 600.352 0 0 1-35.776-47.146667l-5.493333-8.138666-5.333334-8.16-3.893333-6.122667-3.797333-6.101333-4.906667-8.128-2.378667-4.053334-2.336-4.021333-4.512-8-2.186666-3.968-2.133334-3.946667-4.096-7.786666-1.973333-3.861334-1.909333-3.808-3.648-7.509333c-13.525333-28.48-21.770667-53.098667-22.56-68.597333-0.544-10.901333 2.986667-26.538667 9.802666-44.992l1.397334-3.733334 2.709333-6.805333 0.714667-1.738667 0.736-1.749333 3.093333-7.104 2.485333-5.450667 2.613334-5.546666 3.701333-7.530667 3.936-7.658667 4.149333-7.765333 2.154667-3.914667 2.208-3.946666 4.565333-7.936c3.104-5.312 6.346667-10.666667 9.706667-16.021334l5.12-8.042666 5.290667-8.042667 1.354666-2.005333 1.354667-2.005334 5.536-8a588.736 588.736 0 0 1 32.864-42.602666 567.338667 567.338667 0 0 1 36.106667-38.741334l-36.277334-36.288a32 32 0 0 1 43.712-46.688z m5.226667 162.997334l-4.021333 4.8-3.978667 4.885333-5.226667 6.602667-1.28 1.664-1.28 1.674666-5.066666 6.730667-2.485334 3.392-4.885333 6.816-1.205333 1.706667-1.194667 1.706666-4.693333 6.858667-4.554667 6.848-1.109333 1.706667-1.109334 1.706666-4.330666 6.805334-1.066667 1.696-1.045333 1.685333-4.096 6.72-0.992 1.653333-0.992 1.664-3.84 6.570667-3.658667 6.453333-3.477333 6.304-3.274667 6.144-3.072 5.962667-2.869333 5.76-2.645334 5.525333-0.629333 1.344-0.608 1.333334-2.314667 5.141333-2.069333 4.874667-0.48 1.173333-0.469333 1.141333-1.706667 4.416-0.373333 1.045334-0.373334 1.034666-1.312 3.893334-0.565333 1.813333-0.490667 1.728-0.768 3.146667c-0.533333 2.453333-0.768 4.48-0.693333 6.037333 0.042667 0.821333 0.256 2.005333 0.629333 3.52l0.309334 1.194667 0.789333 2.741333 1.013333 3.168 1.237334 3.573333 1.44 3.946667 1.653333 4.266667 1.845333 4.586666 2.026667 4.832 2.208 5.077334 3.626667 7.968 4 8.298666 1.408 2.816a548.032 548.032 0 0 0 69.706666 105.397334C314.890667 759.072 405.973333 810.666667 512 810.666667c70.026667 0 133.909333-22.538667 190.538667-62.869334l-94.624-94.613333A169.877333 169.877333 0 0 1 512 682.666667c-94.261333 0-170.666667-76.405333-170.666667-170.666667 0-35.562667 10.88-68.586667 29.482667-95.914667l-98.624-98.645333a499.808 499.808 0 0 0-32.533333 34.826667zM512 149.333333c127.029333 0 234.773333 61.088 319.68 161.738667a600.352 600.352 0 0 1 35.776 47.146667l5.493333 8.138666 5.333334 8.16 3.893333 6.122667 3.797333 6.101333 4.906667 8.128 2.378667 4.053334 2.336 4.021333 4.512 8 2.186666 3.968 2.133334 3.946667 4.096 7.786666 1.973333 3.861334 1.909333 3.808 3.648 7.509333c13.525333 28.48 21.770667 53.098667 22.56 68.597333 0.544 10.901333-2.986667 26.538667-9.802666 44.992l-1.397334 3.733334-2.709333 6.805333-0.714667 1.738667-0.736 1.749333-3.093333 7.104-2.485333 5.450667-2.613334 5.546666-3.701333 7.530667-3.936 7.658667-4.149333 7.765333-2.154667 3.914667-2.208 3.946666-4.565333 7.936c-3.104 5.312-6.346667 10.666667-9.706667 16.021334l-5.12 8.042666-5.290667 8.042667-1.354666 2.005333-1.354667 2.005334-5.536 8a596.554667 596.554667 0 0 1-28.085333 36.906666l-45.418667-45.429333 5.098667-6.442667 1.28-1.664 1.28-1.674666 5.066666-6.730667 2.485334-3.392 4.885333-6.816 1.205333-1.706667 1.194667-1.706666 4.693333-6.858667 4.554667-6.848 1.109333-1.706667 1.109334-1.706666 4.330666-6.805334 1.066667-1.696 1.045333-1.685333 4.096-6.72 0.992-1.653333 0.992-1.664 3.84-6.570667 3.658667-6.453333 3.477333-6.304 3.274667-6.144 3.072-5.962667 2.869333-5.76 2.645334-5.525333 0.629333-1.344 0.608-1.333334 2.314667-5.141333 2.069333-4.874667 0.48-1.173333 0.469333-1.141333 1.706667-4.416 0.373333-1.045334 0.373334-1.034666 1.312-3.893334 0.565333-1.813333 0.490667-1.728 0.768-3.146667c0.533333-2.453333 0.768-4.48 0.693333-6.037333a20.544 20.544 0 0 0-0.629333-3.52l-0.309334-1.194667-0.789333-2.741333-1.013333-3.168-1.237334-3.573333-1.44-3.946667-1.653333-4.266667-1.845333-4.586666-2.026667-4.832-2.208-5.077334-3.626667-7.968-4-8.298666-1.408-2.816a548.032 548.032 0 0 0-69.706666-105.397334C709.109333 264.928 618.026667 213.333333 512 213.333333c-48.746667 0-94.506667 10.922667-136.928 31.146667l-47.552-47.562667C383.445333 166.261333 445.184 149.333333 512 149.333333zM405.333333 512c0 58.912 47.754667 106.666667 106.666667 106.666667a106.208 106.208 0 0 0 49.333333-12.064L417.386667 462.666667A106.208 106.208 0 0 0 405.333333 512z m106.666667-170.666667c94.261333 0 170.666667 76.405333 170.666667 170.666667 0 12.426667-1.333333 24.533333-3.850667 36.213333l-63.733333-63.733333a106.858667 106.858667 0 0 0-75.562667-75.562667l-63.744-63.733333A171.328 171.328 0 0 1 512 341.333333z"
                            ></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                  <!-- 确认密码 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('signup.confirm.password') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field">
                    <span class="comet-input-label-wrapper comet-input-password">
                      <span class="comet-input-label-content">
                        <input maxlength="40" type="password" :placeholder="$t('signup.confirm.password')" autocapitalize="off" class="comet-input" v-model="params.confirm_passwd" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                        <span class="comet-icon comet-icon-watchingoff comet-input-password-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path
                              d="M234.421333 189.269333l1.536 1.44 597.333334 597.333334a32 32 0 0 1-43.712 46.688l-1.536-1.44-39.722667-39.712C679.498667 845.184 600.170667 874.666667 512 874.666667c-127.029333 0-234.773333-61.088-319.68-161.738667a600.352 600.352 0 0 1-35.776-47.146667l-5.493333-8.138666-5.333334-8.16-3.893333-6.122667-3.797333-6.101333-4.906667-8.128-2.378667-4.053334-2.336-4.021333-4.512-8-2.186666-3.968-2.133334-3.946667-4.096-7.786666-1.973333-3.861334-1.909333-3.808-3.648-7.509333c-13.525333-28.48-21.770667-53.098667-22.56-68.597333-0.544-10.901333 2.986667-26.538667 9.802666-44.992l1.397334-3.733334 2.709333-6.805333 0.714667-1.738667 0.736-1.749333 3.093333-7.104 2.485333-5.450667 2.613334-5.546666 3.701333-7.530667 3.936-7.658667 4.149333-7.765333 2.154667-3.914667 2.208-3.946666 4.565333-7.936c3.104-5.312 6.346667-10.666667 9.706667-16.021334l5.12-8.042666 5.290667-8.042667 1.354666-2.005333 1.354667-2.005334 5.536-8a588.736 588.736 0 0 1 32.864-42.602666 567.338667 567.338667 0 0 1 36.106667-38.741334l-36.277334-36.288a32 32 0 0 1 43.712-46.688z m5.226667 162.997334l-4.021333 4.8-3.978667 4.885333-5.226667 6.602667-1.28 1.664-1.28 1.674666-5.066666 6.730667-2.485334 3.392-4.885333 6.816-1.205333 1.706667-1.194667 1.706666-4.693333 6.858667-4.554667 6.848-1.109333 1.706667-1.109334 1.706666-4.330666 6.805334-1.066667 1.696-1.045333 1.685333-4.096 6.72-0.992 1.653333-0.992 1.664-3.84 6.570667-3.658667 6.453333-3.477333 6.304-3.274667 6.144-3.072 5.962667-2.869333 5.76-2.645334 5.525333-0.629333 1.344-0.608 1.333334-2.314667 5.141333-2.069333 4.874667-0.48 1.173333-0.469333 1.141333-1.706667 4.416-0.373333 1.045334-0.373334 1.034666-1.312 3.893334-0.565333 1.813333-0.490667 1.728-0.768 3.146667c-0.533333 2.453333-0.768 4.48-0.693333 6.037333 0.042667 0.821333 0.256 2.005333 0.629333 3.52l0.309334 1.194667 0.789333 2.741333 1.013333 3.168 1.237334 3.573333 1.44 3.946667 1.653333 4.266667 1.845333 4.586666 2.026667 4.832 2.208 5.077334 3.626667 7.968 4 8.298666 1.408 2.816a548.032 548.032 0 0 0 69.706666 105.397334C314.890667 759.072 405.973333 810.666667 512 810.666667c70.026667 0 133.909333-22.538667 190.538667-62.869334l-94.624-94.613333A169.877333 169.877333 0 0 1 512 682.666667c-94.261333 0-170.666667-76.405333-170.666667-170.666667 0-35.562667 10.88-68.586667 29.482667-95.914667l-98.624-98.645333a499.808 499.808 0 0 0-32.533333 34.826667zM512 149.333333c127.029333 0 234.773333 61.088 319.68 161.738667a600.352 600.352 0 0 1 35.776 47.146667l5.493333 8.138666 5.333334 8.16 3.893333 6.122667 3.797333 6.101333 4.906667 8.128 2.378667 4.053334 2.336 4.021333 4.512 8 2.186666 3.968 2.133334 3.946667 4.096 7.786666 1.973333 3.861334 1.909333 3.808 3.648 7.509333c13.525333 28.48 21.770667 53.098667 22.56 68.597333 0.544 10.901333-2.986667 26.538667-9.802666 44.992l-1.397334 3.733334-2.709333 6.805333-0.714667 1.738667-0.736 1.749333-3.093333 7.104-2.485333 5.450667-2.613334 5.546666-3.701333 7.530667-3.936 7.658667-4.149333 7.765333-2.154667 3.914667-2.208 3.946666-4.565333 7.936c-3.104 5.312-6.346667 10.666667-9.706667 16.021334l-5.12 8.042666-5.290667 8.042667-1.354666 2.005333-1.354667 2.005334-5.536 8a596.554667 596.554667 0 0 1-28.085333 36.906666l-45.418667-45.429333 5.098667-6.442667 1.28-1.664 1.28-1.674666 5.066666-6.730667 2.485334-3.392 4.885333-6.816 1.205333-1.706667 1.194667-1.706666 4.693333-6.858667 4.554667-6.848 1.109333-1.706667 1.109334-1.706666 4.330666-6.805334 1.066667-1.696 1.045333-1.685333 4.096-6.72 0.992-1.653333 0.992-1.664 3.84-6.570667 3.658667-6.453333 3.477333-6.304 3.274667-6.144 3.072-5.962667 2.869333-5.76 2.645334-5.525333 0.629333-1.344 0.608-1.333334 2.314667-5.141333 2.069333-4.874667 0.48-1.173333 0.469333-1.141333 1.706667-4.416 0.373333-1.045334 0.373334-1.034666 1.312-3.893334 0.565333-1.813333 0.490667-1.728 0.768-3.146667c0.533333-2.453333 0.768-4.48 0.693333-6.037333a20.544 20.544 0 0 0-0.629333-3.52l-0.309334-1.194667-0.789333-2.741333-1.013333-3.168-1.237334-3.573333-1.44-3.946667-1.653333-4.266667-1.845333-4.586666-2.026667-4.832-2.208-5.077334-3.626667-7.968-4-8.298666-1.408-2.816a548.032 548.032 0 0 0-69.706666-105.397334C709.109333 264.928 618.026667 213.333333 512 213.333333c-48.746667 0-94.506667 10.922667-136.928 31.146667l-47.552-47.562667C383.445333 166.261333 445.184 149.333333 512 149.333333zM405.333333 512c0 58.912 47.754667 106.666667 106.666667 106.666667a106.208 106.208 0 0 0 49.333333-12.064L417.386667 462.666667A106.208 106.208 0 0 0 405.333333 512z m106.666667-170.666667c94.261333 0 170.666667 76.405333 170.666667 170.666667 0 12.426667-1.333333 24.533333-3.850667 36.213333l-63.733333-63.733333a106.858667 106.858667 0 0 0-75.562667-75.562667l-63.744-63.733333A171.328 171.328 0 0 1 512 341.333333z"
                            ></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                  <!-- 邀请码 -->
                  <div class="fm-seller-tip" v-if="defInvStore == ''">
                    <span>{{ $t('signup.invitation') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field fm-field-phone" v-if="defInvStore == ''">
                    <span class="comet-input-label-wrapper">
                      <span class="comet-input-label-content">
                        <input :placeholder="$t('signup.invitation')" autocapitalize="off" type="text" class="comet-input" v-model="params.inv_code" :disabled="defInvStore !== ''" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 基本信息 -->
        <div class="batman-pc">
          <div class="comet-tabs">
            <div class="comet-tabs-container">
              <div class="comet-tabs-pane comet-tabs-pane-active">
                <div class="shop-title">{{ $t('beseller.store') }}</div>
                <div class="fm-login nc-outer-box">
                  <!-- 店铺名称 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('beseller.store.name') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field fm-field-phone">
                    <span class="comet-input-label-wrapper">
                      <span class="comet-input-label-content">
                        <input :placeholder="$t('beseller.store.name')" autocapitalize="off" type="text" class="comet-input" v-model="params.store_name" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                  <!-- 店铺地址 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('beseller.store.address') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field fm-field-phone">
                    <span class="comet-input-label-wrapper">
                      <span class="comet-input-label-content">
                        <input :placeholder="$t('beseller.store.address')" autocapitalize="off" type="text" class="comet-input" v-model="params.store_address" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                  <button @click="onNext()" type="submit" class="comet-btn comet-btn-primary comet-btn-large comet-btn-block login-submit">
                    <span>{{ $t('signup.next') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二步验证码 -->
      <div class="login-container" v-if="step == 2">
        <!-- 基本信息 -->
        <div class="batman-pc">
          <div class="comet-tabs">
            <div class="comet-tabs-container">
              <div class="comet-tabs-pane comet-tabs-pane-active">
                <div class="shop-title">{{ $t('signup.email.code') }}</div>
                <div class="fm-login nc-outer-box">
                  <!-- 店铺名称 -->
                  <div class="fm-seller-tip">
                    <div>{{ $t('signup.your.email') }}</div>
                    <div style="font-size: 16px; font-weight: 600">
                      {{ params.email }}
                    </div>
                  </div>
                  <div class="fm-field fm-field-phone"></div>
                  <!-- 店铺地址 -->
                  <div class="fm-seller-tip">
                    <span>{{ $t('signup.code.text') }}</span>
                    <span class="text-primary">*</span>
                  </div>
                  <div class="fm-field fm-field-phone code-input">
                    <span class="comet-input-label-wrapper code-inpt">
                      <span class="comet-input-label-content">
                        <input :placeholder="$t('signup.code.text')" autocapitalize="off" type="text" class="comet-input" v-model="params.code" />
                      </span>
                      <span class="comet-input-suffix">
                        <span class="comet-icon comet-icon-wrongfill comet-input-clear-icon-hidden comet-input-clear-icon">
                          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333zM405.088 359.936a32 32 0 0 0-43.712 46.688L466.741333 512l-105.365333 105.376-1.44 1.536a32 32 0 0 0 46.688 43.712L512 557.258667l105.376 105.365333 1.536 1.44a32 32 0 0 0 43.712-46.688L557.258667 512l105.365333-105.376 1.44-1.536a32 32 0 0 0-46.688-43.712L512 466.741333l-105.376-105.365333z"></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                    <span class="code-btn">
                      <button @click="onSendCode()" style="cursor: pointer; background: linear-gradient(90deg, #000, #000); color: #fff; border: none; border-radius: 5px; height: 100%; padding: 0 10px">
                        <span>{{ codeBtnText }}</span>
                      </button>
                      <!-- <a @click="onSendCode()">{{ codeBtnText }}</a> -->
                    </span>
                  </div>
                  <button @click="onSignup()" type="submit" class="comet-btn comet-btn-primary comet-btn-large comet-btn-block login-submit">
                    <span>{{ $t('signup.submit.signup') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 确认收货 -->
    <Confirm ref="confirm" :isCancel="false" :title="msgTitle" :content="msgContent" @onOk="onConfirmOk()" @onClose="onConfirmOk()"></Confirm>
  </div>
</template>

<script>
import { countdown } from '@/utils/tools'
import Confirm from '@/components/member/Confirm'
// import crypto from '@/utils/crypto'
import Base64 from '@/utils/base64'
export default {
  name: 'besellerVue',
  components: {
    Confirm
  },
  data() {
    return {
      //当前步骤
      step: 1,

      //参数
      params: {
        type: 2,
        email: '',
        passwd: '',
        confirm_passwd: '',
        inv_code: '',
        store_name: '',
        store_address: '',
        code: '',
        inv_sid: ''
      },

      //发送验证码
      hasSend: true,
      codeBtnText: this.$t('base.send.code'),

      //消息内容
      msgTitle: '',
      msgContent: '',
      msgRecord: {},

      //默认值
      defInvStore: '',
      defUid: ''
    }
  },
  created() {
    let param = this.$route.query
    console.log('param', param)
    if (param.code) {
      //解析
      //let sid = crypto.get(param.code)
      let base = new Base64()
      let sid = base.decode(param.code)
      console.log('sid', sid)
      //this.params.inv_sid = param.sid
      //this.params.inv_code = param.code
      //this.defInvStore = param.code
      if (sid != '') {
        let str = sid.split('&', 2)
        this.params.inv_sid = str[0]
        this.params.inv_code = str[1]
        this.defInvStore = str[1]
      }
    }
  },
  methods: {
    valid() {
      // email.valid
      if (this.params.email.length == 0 || !this.$common.checkEmail(this.params.email)) {
        this.$message.warning(this.$t('email.valid'))
        return false
      }

      if (this.params.passwd.length == 0) {
        this.$message.warning(this.$t('password.valid'))
        return false
      }

      if (this.params.confirm_passwd.length == 0) {
        this.$message.warning(this.$t('confirm.password.valid'))
        return false
      }

      if (this.params.passwd !== this.params.confirm_passwd) {
        this.$message.warning(this.$t('confirm.passwords.not.match'))
        return false
      }

      if (this.params.inv_code.length == 0) {
        this.$message.warning(this.$t('invitation.code.valid'))
        return false
      }

      if (this.params.store_name.trim().length == 0) {
        this.$message.warning(this.$t('store.name.valid'))
        return false
      }

      if (this.params.store_address.trim().length == 0) {
        this.$message.warning(this.$t('store.address.valid'))
        return false
      }

      return true
    },
    /**
     * 下一步
     */
    onNext() {
      if (!this.valid()) {
        return
      }

      //验证
      let email = this.$common.rmSpaces(this.params.email)
      let key = this.$md5(email)
      let inv_code = this.$common.rmSpaces(this.params.inv_code)
      let that = this
      this.$api.auth
        .checkEmail({
          email: email,
          inv_code: inv_code,
          store_name: this.params.store_name,
          type: 2
        })
        .then((res) => {
          if (res.code == 1) {
            that.$message.error(res.msg)
            return
          }
          //next
          that.step = 2
          countdown.run(key, that.CallTime)
        })
    },
    /**
     * 发送验证码
     */
    onSendCode() {
      if (!this.hasSend) {
        return
      }
      let email = this.$common.rmSpaces(this.params.email)
      let key = this.$md5(email)

      this.$message.loading({ content: 'loading...', key: 'msg' })

      let that = this
      this.$api.code
        .sendCode({
          email: email,
          scene: 'signup'
        })
        .then((res) => {
          that.$message.success({
            content: this.$t('base.send.success') /* + ",code:" + res.data.code*/,
            key: 'msg'
          })
          countdown.start(key, res.data.exp)
          countdown.run(key, that.CallTime)
        })
    },
    /**
     * 倒计时回调
     * @param {*} time
     */
    CallTime(time) {
      console.log(time)
      if (time == 0) {
        this.hasSend = true
        this.codeBtnText = this.$t('base.send.code')
      } else {
        this.hasSend = false
        this.codeBtnText = this.$t('base.send.time', {
          time: time
        })
      }
    },
    /**
     * 注册
     */
    onSignup() {
      if (this.params.code.length == 0) {
        this.$message.warning(this.$t('code.empty'))
        return false
      }

      let that = this
      this.$api.auth.signup(this.params).then(() => {
        that.$message.success(this.$t('signup.success'))
        that.onSuccess()
        setTimeout(function () {
          countdown.clear()
        }, 1000)
      })
    },
    onSuccess() {
      this.msgTitle = this.$t('apply.success')
      this.msgContent = this.$t('apply.success.desc')
      this.$refs.confirm.open()
    },
    onConfirmOk() {
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style scoped>
.fm-login {
    margin-top: 12px;
}
.fm-field {
    position: relative;
    margin-bottom: 20px;
}
.login-submit {
  margin-top: 20px;
}
body {
  background-color: #fff !important;
}
#headerReg {
  border-bottom: 1px solid #eee;
  padding: 16px 0;
}
.header990 {
  width: 990px;
  margin: auto;
  text-align: center;
}
#aliLogo {
  font: 700 24px verdana;
  display: inline-block;
}

.header990 div {
  /* color: #f47b12; */
  color: #000;
}
#aliLogo a {
  background: url('@/static/logo.png') no-repeat;
  display: block;
  height: 60px;
  width: 360px;
  overflow: hidden;
  text-indent: -9999px;
  float: left;
  background-size: contain;
}

/* login */
.login-container {
  position: relative;
  width: 550px;
  margin: 12px auto 0;
  background-color: #fff;
  padding: 10px 30px 50px 30px;
  margin-bottom: 50px;
}

.comet-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #222;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
}

.comet-tabs-wrapper {
  text-align: center;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
}

.comet-tabs-nav {
  padding: 16px 0;
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  justify-content: center;
  position: relative;
}

.comet-tabs-nav-item {
  position: relative;
  cursor: pointer;
  padding: 0 16px;
  flex-wrap: nowrap;
  font-size: 16px;
  color: #222;
  white-space: nowrap;
  line-height: 24px;
}
.comet-tabs-nav-item-active {
  font-weight: 700;
}

.comet-tabs-nav-item {
  position: relative;
  cursor: pointer;
  padding: 0 16px;
  flex-wrap: nowrap;
  font-size: 16px;
  color: #222;
  white-space: nowrap;
  line-height: 24px;
}

.fm-seller-tip {
  margin-bottom: 8px;
}

.comet-input {
  padding-top: 0 !important;
}

.text-primary {
  color: #e62e04 !important;
}

.shop-title {
  padding: 15px 0px;
  font-size: 17px;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6 !important;
}
.code-btn {
  min-width: 25%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.code-input {
  display: flex;
  align-items: center;
}

.code-inpt {
  min-width: 60%;
  flex: 1 1;
}
</style>
